export default __webpack_public_path__ + "static/media/gallery_01.41344e3b.jpg";